module.exports = __webpack_public_path__ + "img/14.0e721b2d.jpg";